import { SvgIcon } from "@progress/kendo-react-common";
import { checkboxIcon } from "@progress/kendo-svg-icons";
import { FunctionComponent } from "react";
import { UserClass, Zone } from "../api";
import { PolicyRules } from "./PolicyRules";
import { PolicyTimeSpans } from "./PolicyTimeSpans";
import { ZoneArea } from "./ZoneArea";
import classes from "./ZoneInventory.module.scss";

export const ZoneInventory: FunctionComponent<{
  className?: string;
  zone: Zone;
}> = ({ className, zone }) => {
  return (
    <div className={`${classes.content} ${className}`}>
      <ZoneArea zone={zone} />

      <div className={classes.policies}>
        {zone.Policies.map((x, index) => (
          <div key={index} className={classes.policy}>
            <div className={classes.timespans}>
              <div>
                <PolicyTimeSpans timeSpans={x.TimeSpans}></PolicyTimeSpans>
                {!x.TimeSpans?.length &&
                  x.Rules.some((x) =>
                    x.UserClasses?.some((y) => y === UserClass.SpecialEvents)
                  ) && <span>{UserClass.SpecialEvents}</span>}
              </div>
              <SvgIcon
                svgClassName="checkbox"
                size="xxlarge"
                icon={checkboxIcon}
              />
            </div>
            <div className={classes.rules}>
              <PolicyRules rules={x.Rules}></PolicyRules>
            </div>
          </div>
        ))}
      </div>

      <div className={classes.notes}>Note Differences:</div>
    </div>
  );
};
